exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.global[data-v-65ba0e18] {\r\n  position: fixed;\r\n  inset: 0;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-align: center;\r\n      align-items: center;\r\n  -ms-flex-pack: center;\r\n      justify-content: center;\r\n  background-color: rgb(255 255 255 / 44%);\r\n  z-index: 1;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-65ba0e18","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./scripts/src/components/loader.vue
// module id = 623
// module chunks = 0